export default function getDataFromPlayer(match = []) {
  return {
    ...match,
    ...match.tftProfile,
    units: match.playerMatchUnits
      ? match.playerMatchUnits.map((u) => {
          return { ...u, ...u.unit };
        })
      : [],
    traits: match.playerMatchTraits
      ? match.playerMatchTraits.map((t) => {
          return { ...t, ...t.trait };
        })
      : [],
    augments: match.augments,
    placement: match.placement,
    gold_left: match.goldLeft,
    last_round: match.lastRound,
    level: match.level,
    players_eliminated: match.playersEliminated,
    time_eliminated: match.timeEliminated,
    total_damage_to_players: match.totalDamageToPlayers,
  };
}

export function getDataFromPlayers(matches = []) {
  return matches.map((match) => getDataFromPlayer(match));
}
